// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { ApmVuePlugin } from '@elastic/apm-rum-vue';
import { apmMonitor } from '@/service/apmMonitor';
import { config, setConfig } from 'CONFIG';
import Vuex from 'vuex';
import store from '@/store';
import i18n from 'LANG';
import '@/common/css/base.less';
import '@/common/css/skin.less';
import VueTouch from 'vue-touch';
import nprogress from 'nprogress';
import VueLazyload from 'vue-lazyload';
import { getFeature } from '@/common/js/utils';
import { getOfficialUrl } from '@/common/js/url';
import user from '@/api/user';
import * as filters from '@/filter';
import { getPaymentImage } from '@/common/js/getPaymentImage.js';
import '@reolink-web/gdpr-cookies/dist/style.css';
import '@/icon/style.css';
import '@reolink-web/components.color/dist/colors.css';
import 'nprogress/nprogress.css';
import { countriesManager } from './lib';
// test component
// import '@/test/console';

// mock.js
import '@/test/mock';
import { checkOldUrlParams, convertUrlParams } from './utils/url/query';
import { getPaymentsMethods } from './api/payment';
import { unfoldError } from './common/js/notice';
import { callAppApi } from '@reolink-web/app-sdk';
import { Async } from '@reolink-web/utils';
import { registerServiceWorker } from './utils/sw';
import { startSwReadyState, swReadyState, secureMediaDirective } from '@/service/secureMedia';
import '@/common/js/owl.carousel.min.js';

Reflect.set( window, 'jquerySelf', $ );
import RichText from './basic/RichText.vue';
import { getCloudCountries } from './api/cloud';
import { EApmTransactionName } from './config/apm';

Vue.prototype.FEATURE = ( featrue ) => {

    return getFeature( featrue );

};

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };

Vue.prototype.getOfficialUrl = getOfficialUrl;

Vue.prototype.getPaymentImage = getPaymentImage;

Vue.prototype.transactionNames = EApmTransactionName;

Vue.use( VueLazyload as any );

// Elastic APM RUM 初始化
const apm = apmMonitor.initApm();
if ( apm ) {

    Vue.use( ApmVuePlugin, {
        apm,
        router,
        captureErrors: true
    });

}

// progress
nprogress.configure({ showSpinner: false });

Vue.config.productionTip = false;

// 页面全局点击
Vue.prototype.globalClick = ( callback ) => {

    $( document ).on( 'click', callback );

};

// touch
Vue.use( VueTouch, { name: 'v-touch' });

Vue.use( Vuex );

Vue.directive( 'secure-media', secureMediaDirective );

Vue.directive( 'anchor', {
    bind( el, binding ) {

        el.addEventListener( 'click', ( event ) => {

            event.preventDefault();

            const selector = el.getAttribute( 'href' );
            const targetElement = document.querySelector( binding.arg ??  selector ?? '' );
            if ( !targetElement ) return;
            const headerElement = document.getElementById( 'header' ); // <-- 替换成你的导航栏ID
            const headerHeight = headerElement ? headerElement.offsetHeight : 0;

            const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = targetPosition - headerHeight;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });

        });

    }
});

Vue.component( 'RichText', RichText );

// vue模版中的全局过滤器
for ( const key in filters ) {

    Vue.filter( key, filters[key] );

}

const initapp = async (): Promise<void> => {

    await Promise.all( [
        countriesManager.update(),
    ] );

    /* eslint-disable no-new */
    new Vue({

        el: '#app',
        router,
        components: { App },
        template: '<App/>',
        i18n,
        store
    });

};

const init = async (): Promise<void> => {

    // 兼容低版本系统的App
    // https://github.com/kazupon/vue-i18n/issues/215
    window.global = window;
    // 启动 SW 就绪状态监听（500ms 内未收到 SW_READY 即视为不可用并启用降级）
    startSwReadyState();
    // 不能让 paymentMethods 接口或 SW 注册影响主流程，挂掉时正常继续流程
    try {

        await registerServiceWorker().catch(( error ) => {

            console.error( 'Service Worker registration failed, fallback enabled.', error );
            swReadyState.markUnavailable();

        });
        const [,methodInfo, countryData] = await Promise.all( [countriesManager.update(), getPaymentsMethods(), getCloudCountries( 'en' )] );
        config.showRefundWarning = methodInfo.items.some( item => item.gateway === 'payoneer' );
        config.countryData = countryData;

    } catch ( e ) {

        console.error( e );
        unfoldError( 'errors.server_error' );

    }
    if ( !global.Intl ) {

        try {

            await import( 'intl' );
            await import( 'intl/locale-data/jsonp/en.js' );

            await initapp();

        }
        catch ( error ) {

            console.warn( error );

        }

    } else {

        await initapp();

    }

};

function initAfterWebviewInit (): void {

    Async.invokeAsync( async () => {

        await callAppApi( 'getToken' ).then( user.setTokenFromApp.bind( user ));
        await callAppApi( 'getAppUrl' ).then(( urlData ) => {

            setConfig( 'app_url', urlData.url );

        });
        await init();

    });

}

/**
 * 在app webview内
 *
 * 1、先启动WebViewJavascriptBridge（Android）
 *
 * 2、获取token和client id
 *
 * 3、初始化vue实例
 */
const initInApp = (): void => {

    let webviewInit = true;
    if ( config.client === 'Android' ) {

        if ( !window.WebViewJavascriptBridge ) {

            webviewInit = false;
            document.addEventListener(
                'WebViewJavascriptBridgeReady'
                , initAfterWebviewInit,
                false
            );

        }

    } else {

        window.IOSCaller = {};
        window.responseToJS = function ( name, data ) {

            window.IOSCaller[ name ]( data );

        };

    }
    if ( webviewInit ) {

        initAfterWebviewInit();

    }

};

const currentUrl = window.location.href;
if ( checkOldUrlParams( currentUrl )) {

    location.replace(
        convertUrlParams( currentUrl )
    );

}

if ( config.platform === 'app' ) {

    $( 'body' ).addClass( 'app-not-show' );

    /**
     * ready回调可以保证WebViewJavascriptBridge已加载
     */
    $( function () {

        setTimeout( initInApp, 0 );

    });

} else {

    init().catch( console.error );

}
